import { render, staticRenderFns } from "./ListOrderPendingValidationComponent.vue?vue&type=template&id=2d452862&"
import script from "./ListOrderPendingValidationComponent.vue?vue&type=script&lang=js&"
export * from "./ListOrderPendingValidationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports